export const CAMPAIGN_STATUS = {
  RUNNING: 'RUNNING',
  PENDING: 'PENDING',
  STOPPED: 'STOPPED',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
  COMPLETED: 'COMPLETED',
  DRAFT: 'DRAFT',
  READY: 'READY',
  CONNECTED: 'CONNECTED',
} as const;

export type CampaignStatusType =
  (typeof CAMPAIGN_STATUS)[keyof typeof CAMPAIGN_STATUS];

export const SCREEN_STATUS = {
  CONNECTED: 'CONNECTED',
  APPROVED: 'APPROVED',
  PENDING: 'PENDING',
  REJECTED: 'REJECTED',
  DELIVERED: 'DELIVERED',
} as const;

export type ScreenStatusType =
  (typeof SCREEN_STATUS)[keyof typeof SCREEN_STATUS];

export const CAMPAIGN_STATUS_COLORS: Record<string, string> = {
  [CAMPAIGN_STATUS.RUNNING]: '#2196F3',
  [CAMPAIGN_STATUS.CONNECTED]: '#2E7D32',
  [CAMPAIGN_STATUS.APPROVED]: '#2E7D32',
  [CAMPAIGN_STATUS.COMPLETED]: '#2E7D32',
  [CAMPAIGN_STATUS.PENDING]: '#EF6C00',
  [CAMPAIGN_STATUS.DRAFT]: '#EF6C00',
  [CAMPAIGN_STATUS.STOPPED]: '#EF6C00',
  [CAMPAIGN_STATUS.REJECTED]: '#D32F2F',
} as const;

export const SCREEN_STATUS_COLORS: Record<string, string> = {
  [SCREEN_STATUS.CONNECTED]: '#2E7D32',
  [SCREEN_STATUS.APPROVED]: '#D4A520',
  [SCREEN_STATUS.PENDING]: '#EF6C00',
  [SCREEN_STATUS.REJECTED]: '#D32F2F',
  [SCREEN_STATUS.DELIVERED]: '#2E7D32',
} as const;

export const STATUS_COLORS = CAMPAIGN_STATUS_COLORS;

export const RETARGETING_CAMPAIGN_STATUS = {
  DRAFT: 'DRAFT',
  SUBMITTED: 'SUBMITTED',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
} as const;

export type RetargetingCampaignStatusType =
  (typeof RETARGETING_CAMPAIGN_STATUS)[keyof typeof RETARGETING_CAMPAIGN_STATUS];

export const RETARGETING_STATUS_LABELS: Record<string, string> = {
  [RETARGETING_CAMPAIGN_STATUS.DRAFT]: 'Draft',
  [RETARGETING_CAMPAIGN_STATUS.SUBMITTED]: 'Under approval',
  [RETARGETING_CAMPAIGN_STATUS.APPROVED]: 'Approved',
  [RETARGETING_CAMPAIGN_STATUS.REJECTED]: 'Rejected',
} as const;

export const RETARGETING_STATUS_COLORS: Record<string, string> = {
  DRAFT: '#EF6C00',
  'UNDER APPROVAL': '#EF6C00',
  APPROVED: '#2E7D32',
  REJECTED: '#D32F2F',
} as const;
